import HostedPaymentGateway from "./hostedPaymentGateway";

function HostedPaymentGatewayComponent(){
    return(
        <div>
             <HostedPaymentGateway />
        </div>
    );
}

export default HostedPaymentGatewayComponent;
